module.exports = __webpack_public_path__ + "static/media/file-gradient.be666691.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/file-gradient.png
// module id = 117
// module chunks = 0